import Modal from '../Modal';
import PropTypes from 'prop-types';

const InfoModal = ({
  isOpen,
  onClose,
  contentWidth,
  title,
  content,
  onSave,
  buttonPosition,
  buttonText,
  hideHeader = false
}) => {
  const handleConfirmation = () => {
    onSave();
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentWidth={contentWidth}
      detailHeight={'auto'}
      hideHeader={hideHeader}
      titleName={title}>
      <div className="confirmation-wrapper">
        <div className="confirmation-content">
          {content}
        </div>
        <div className={`d-flex justify-content-${buttonPosition} gap-2 pt-3`}>
          <button
            className={'btn btn-castleWhite btn-width'}
            onClick={handleConfirmation}>
            {buttonText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

InfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contentWidth: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  buttonPosition: PropTypes.string,
  content: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  title: PropTypes.string,
  hideHeader: PropTypes.bool
};

export default InfoModal;
